import { Controller } from "@hotwired/stimulus"

// Permite rotar el iframe del PDF en 90° increments.
// Rotación inicial viene del upload (persistida). Al rotar, persiste via PATCH.
export default class extends Controller {
  static targets = ["frame", "wrap"]
  static values = {
    initialRotation: { type: Number, default: 0 },
    persistUrl: String,
    csrf: String
  }

  connect() {
    this.angle = this.initialRotationValue % 360
    // Esperar a que el iframe cargue para conocer dimensiones reales
    setTimeout(() => this.apply(), 300)
  }

  rotateRight() { this.angle = (this.angle + 90) % 360; this.apply(); this.persist() }
  rotateLeft()  { this.angle = (this.angle + 270) % 360; this.apply(); this.persist() }
  reset()       { this.angle = 0; this.apply(); this.persist() }

  apply() {
    if (!this.hasFrameTarget) return
    const wrap = this.wrapTarget
    const frame = this.frameTarget
    const w = wrap.clientWidth
    const h = wrap.clientHeight

    if (this.angle === 90 || this.angle === 270) {
      // Iframe se renderiza con dimensiones intercambiadas + se centra
      frame.style.width = h + "px"
      frame.style.height = w + "px"
      frame.style.position = "absolute"
      frame.style.left = ((w - h) / 2) + "px"
      frame.style.top = ((h - w) / 2) + "px"
    } else {
      frame.style.width = "100%"
      frame.style.height = "100%"
      frame.style.position = "static"
      frame.style.left = "auto"
      frame.style.top = "auto"
    }
    frame.style.transform = `rotate(${this.angle}deg)`
  }

  persist() {
    if (!this.hasPersistUrlValue || !this.persistUrlValue) return
    fetch(this.persistUrlValue, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": this.csrfValue,
        "Accept": "application/json"
      },
      body: JSON.stringify({ pdf_rotation: this.angle })
    }).catch(err => console.warn("pdf rotation persist failed:", err))
  }
}
